import { orderService } from '../services';
import { resetSessionData, setStartTime, requestError } from './globals';
import { resetTicketData } from './tickets';
import { resetSeatsData } from './seats';
import {clearCard} from './cards';
import { hideModal } from './ui';

/*
  Action creators
*/
export const cancelOrder = (sessionId, resetSession, persistData = true) => (dispatch) => {
  dispatch(clearCard());
  if (persistData) {
    dispatch(resetTicketData());
    dispatch(resetSeatsData());
  }
  return orderService('cancel', sessionId).then(() => {
    if (resetSession) {
      dispatch(resetSessionData());
      dispatch(requestError(10009, ""));
    }
    dispatch(hideModal());
  }).catch(console.log);
};

export const resetOrder = (sessionId, isErrorCatch, hideModalFromPayment = false) => (dispatch) => {
  dispatch(hideModal());
  return orderService('reset', sessionId).then((data) => {
    if (data.data.status_code > 0 && isErrorCatch) {
      dispatch(requestError(data.data.status_code, data.data.message));
    } else {
      if(!hideModalFromPayment)
        dispatch(setStartTime(data.data.start_date));
    }
  }).catch(console.log);
};
